import '../scss/main.scss';
import Slider from "./components/slider";
import ProductTable from "./components/productTable";

window.productTable = new ProductTable()


window.swipers = [];
const sliders = document.querySelectorAll("[data-slider]");
if (sliders.length > 0) {
    sliders.forEach((slider) => {
        const type = slider.getAttribute("data-slider");
        window.swipers[type] = new Slider(slider, type);
    });
}

const targetNode = document.querySelector("[data-update-slider]")
if (targetNode) {
    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                const sliders = document.querySelectorAll("[data-slider]");
                sliders.forEach((slider) => {
                    const type = slider.getAttribute("data-slider");
                    window.swipers[type] = new Slider(slider, type);
                });
            }
        }
    });

    const config = {childList: true, subtree: false};
    observer.observe(targetNode, config);
}
